// Grid — responsive auto-fit grid. Either pass `cols` for a fixed column count
// (collapses to fewer columns at tablet/mobile) or `minItemWidth` for an
// auto-fit track that wraps naturally. Desktop-first per Frontend Rules §12.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './grid.css';

export function Grid({ cols, minItemWidth, gap = 4, className, style, children, ...rest }) {
  const gridStyle = {
    '--grid-gap': `var(--s-${gap})`,
    ...(minItemWidth
      ? { gridTemplateColumns: `repeat(auto-fit, minmax(${minItemWidth}px, 1fr))` }
      : { '--grid-cols': cols || 12 }),
    ...style,
  };
  return (
    <div
      className={cx('grid', !minItemWidth && 'grid--fixed', className)}
      style={gridStyle}
      {...rest}
    >
      {children}
    </div>
  );
}

Grid.propTypes = {
  /** Fixed column count (desktop). Ignored when minItemWidth is set. */
  cols: PropTypes.number,
  /** Auto-fit minimum item width in px; columns wrap responsively. */
  minItemWidth: PropTypes.number,
  gap: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 8, 10, 12, 16]),
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default Grid;
